import React from 'react'
import './contact.css'
import { MdOutlineEmail } from 'react-icons/md';
import { SlSocialSkype } from 'react-icons/sl';
import { BsWhatsapp } from 'react-icons/bs';
import { useRef } from 'react';
import emailjs from 'emailjs-com';
import { BsArrowUpSquareFill } from 'react-icons/bs';

const Contact = () => {
  
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_4i4tsmo', 'template_el5e6w4', form.current, 'xvfCMp32obllClFyN')
      
    e.target.reset()
  };
  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>ashraf.tanin@gmail.com</h5>
            <a href='mailto:ashraf.tanin@gmail.com' target='_blank' rel="noreferrer">Send an Email</a>
          </article>
          <article className="contact__option">
            <BsWhatsapp className='contact__option-icon'/>
            <h4>Whatsup</h4>
            <h5>206-468-4106</h5>
            <a href="https://api.whatsapp.com/send?phone+12064684106" target='_blank' rel="noreferrer">Send a Message</a>
          </article>
        </div>

        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full Name' required />
          <input type="email" name='email' placeholder='Your Email Address' required />
          <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
        <div className='scroll__up'>
          <a href='#header'><BsArrowUpSquareFill /></a>
        </div>
        
      </div>
    </section>
  )
}

export default Contact